import { render } from "./WishlistPage.vue?vue&type=template&id=48eda802"
import script from "./WishlistPage.vue?vue&type=script&lang=js"
export * from "./WishlistPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__